
/**
 * Configuration for global mega expansion
 * Defines target cities per country for complete planetary coverage
 */

export interface GlobalExpansionConfig {
  targetCitiesPerCountry: {
    [key: string]: number;
  };
  populationThreshold: number;
  totalTargetCities: number;
}

// Configuration ultra masiva basada en datos reales de población urbana por país
export const GLOBAL_EXPANSION_CONFIG: GlobalExpansionConfig = {
  targetCitiesPerCountry: {
    // Países ultra poblados (más de 100M habitantes) - EXPANSIÓN MASIVA
    'china': 5000,        // Máxima cobertura para China
    'india': 4000,        // Máxima cobertura para India
    'united-states': 2000, // Cobertura completa USA
    'indonesia': 1500,    // Cobertura completa Indonesia
    'pakistan': 1000,     // Expansión masiva
    'brazil': 1800,       // Cobertura completa Brasil
    'nigeria': 1200,      // Expansión masiva
    'bangladesh': 800,    // Expansión masiva
    'russia': 1500,       // Cobertura completa Rusia
    'mexico': 1200,       // Cobertura completa México
    'japan': 800,         // Cobertura completa Japón
    'philippines': 1000,  // Expansión masiva
    'ethiopia': 600,      // Expansión masiva
    'vietnam': 700,       // Expansión masiva
    'turkey': 800,        // Expansión masiva
    'iran': 700,          // Expansión masiva
    'germany': 600,       // Cobertura completa
    'thailand': 600,      // Expansión masiva
    'united-kingdom': 500, // Cobertura completa
    'france': 500,        // Cobertura completa
    'italy': 500,         // Cobertura completa
    'south-africa': 600,  // Expansión masiva
    'myanmar': 500,       // Expansión masiva
    'south-korea': 400,   // Cobertura completa
    'colombia': 600,      // Expansión masiva
    'spain': 450,         // Cobertura completa
    'ukraine': 500,       // Expansión masiva
    'argentina': 600,     // Expansión masiva
    'algeria': 400,       // Expansión masiva
    'sudan': 350,         // Expansión masiva
    'uganda': 300,        // Expansión masiva
    'iraq': 400,          // Expansión masiva
    'poland': 380,        // Cobertura completa
    'canada': 450,        // Cobertura completa
    'afghanistan': 350,   // Expansión masiva
    'morocco': 350,       // Expansión masiva
    'saudi-arabia': 300,  // Expansión masiva
    'uzbekistan': 280,    // Expansión masiva
    'peru': 400,          // Expansión masiva
    'angola': 280,        // Expansión masiva
    'malaysia': 350,      // Expansión masiva
    'mozambique': 250,    // Expansión masiva
    'ghana': 280,         // Expansión masiva
    'yemen': 220,         // Expansión masiva
    'nepal': 250,         // Expansión masiva
    'venezuela': 350,     // Expansión masiva
    'madagascar': 200,    // Expansión masiva
    'cameroon': 220,      // Expansión masiva
    'ivory-coast': 220,   // Expansión masiva
    'north-korea': 200,   // Expansión masiva
    'australia': 300,     // Cobertura completa
    'niger': 150,         // Expansión masiva
    'sri-lanka': 200,     // Expansión masiva
    'burkina-faso': 130,  // Expansión masiva
    'mali': 140,          // Expansión masiva
    'romania': 200,       // Cobertura completa
    'malawi': 120,        // Expansión masiva
    'chile': 250,         // Cobertura completa
    'kazakhstan': 200,    // Expansión masiva
    'zambia': 130,        // Expansión masiva
    'guatemala': 180,     // Expansión masiva
    'ecuador': 200,       // Expansión masiva
    'syria': 180,         // Expansión masiva
    'netherlands': 200,   // Cobertura completa
    'senegal': 140,       // Expansión masiva
    'cambodia': 150,      // Expansión masiva
    'chad': 120,          // Expansión masiva
    'somalia': 110,       // Expansión masiva
    'zimbabwe': 130,      // Expansión masiva
    'guinea': 120,        // Expansión masiva
    'rwanda': 100,        // Expansión masiva
    'benin': 110,         // Expansión masiva
    'burundi': 90,        // Expansión masiva
    'tunisia': 150,       // Expansión masiva
    'bolivia': 150,       // Expansión masiva
    'belgium': 150,       // Cobertura completa
    'haiti': 120,         // Expansión masiva
    'cuba': 140,          // Expansión masiva
    'south-sudan': 100,   // Expansión masiva
    'dominican-republic': 140, // Expansión masiva
    'czech-republic': 150, // Cobertura completa
    'greece': 140,        // Cobertura completa
    'jordan': 120,        // Expansión masiva
    'portugal': 150,      // Cobertura completa
    'azerbaijan': 120,    // Expansión masiva
    'sweden': 150,        // Cobertura completa
    'honduras': 120,      // Expansión masiva
    'united-arab-emirates': 100, // Cobertura completa
    'hungary': 120,       // Cobertura completa
    'tajikistan': 100,    // Expansión masiva
    'austria': 120,       // Cobertura completa
    'papua-new-guinea': 90, // Expansión masiva
    'serbia': 110,        // Cobertura completa
    'israel': 100,        // Cobertura completa
    'switzerland': 120,   // Cobertura completa
    'togo': 90,           // Expansión masiva
    'sierra-leone': 80,   // Expansión masiva
    'laos': 90,           // Expansión masiva
    'paraguay': 100,      // Expansión masiva
    'libya': 90,          // Expansión masiva
    'bulgaria': 100,      // Cobertura completa
    'lebanon': 90,        // Expansión masiva
    'nicaragua': 90,      // Expansión masiva
    'kyrgyzstan': 80,     // Expansión masiva
    'el-salvador': 90,    // Expansión masiva
    'turkmenistan': 80,   // Expansión masiva
    'singapore': 50,      // Cobertura completa (ciudad-estado)
    'denmark': 100,       // Cobertura completa
    'finland': 100,       // Cobertura completa
    'congo': 90,          // Expansión masiva
    'slovakia': 90,       // Cobertura completa
    'norway': 100,        // Cobertura completa
    'oman': 70,           // Expansión masiva
    'palestine': 60,      // Expansión masiva
    'costa-rica': 70,     // Expansión masiva
    'liberia': 60,        // Expansión masiva
    'ireland': 70,        // Cobertura completa
    'central-african-republic': 50, // Expansión básica
    'new-zealand': 80,    // Cobertura completa
    'mauritania': 50,     // Expansión básica
    'panama': 70,         // Expansión masiva
    'kuwait': 50,         // Cobertura completa
    'croatia': 70,        // Cobertura completa
    'moldova': 50,        // Expansión básica
    'georgia': 50,        // Expansión básica
    'eritrea': 40,        // Expansión básica
    'uruguay': 50,        // Cobertura completa
    'bosnia-and-herzegovina': 60, // Cobertura completa
    'mongolia': 50,       // Expansión básica
    'armenia': 40,        // Expansión básica
    'jamaica': 40,        // Expansión básica
    'qatar': 40,          // Cobertura completa
    'albania': 40,        // Expansión básica
    'puerto-rico': 40,    // Expansión básica
    'lithuania': 50,      // Cobertura completa
    'namibia': 40,        // Expansión básica
    'gambia': 30,         // Expansión básica
    'botswana': 30,       // Expansión básica
    'gabon': 30,          // Expansión básica
    'lesotho': 25,        // Expansión básica
    'slovenia': 30,       // Cobertura completa
    'latvia': 30,         // Cobertura completa
    'bahrain': 20,        // Cobertura completa
    'equatorial-guinea': 20, // Expansión básica
    'trinidad-and-tobago': 25, // Expansión básica
    'estonia': 25,        // Cobertura completa
    'timor-leste': 20,    // Expansión básica
    'mauritius': 20,      // Expansión básica
    'cyprus': 20,         // Cobertura completa
    'eswatini': 20,       // Expansión básica
    'djibouti': 15,       // Expansión básica
    'fiji': 15,           // Expansión básica
    'reunion': 15,        // Expansión básica
    'comoros': 10,        // Expansión básica
    'guyana': 15,         // Expansión básica
    'bhutan': 10,         // Expansión básica
    'solomon-islands': 10, // Expansión básica
    'macao': 10,          // Cobertura completa
    'luxembourg': 10,     // Cobertura completa
    'suriname': 10,       // Expansión básica
    'cape-verde': 10,     // Expansión básica
    'maldives': 8,        // Expansión básica
    'malta': 10,          // Cobertura completa
    'brunei': 8,          // Expansión básica
    'belize': 8,          // Expansión básica
    'bahamas': 8,         // Expansión básica
    'iceland': 10,        // Cobertura completa
    'barbados': 8,        // Expansión básica
    'vanuatu': 8,         // Expansión básica
    'sao-tome-and-principe': 5, // Expansión básica
    'samoa': 5,           // Expansión básica
    'saint-lucia': 5,     // Expansión básica
    'kiribati': 3,        // Expansión básica
    'micronesia': 3,      // Expansión básica
    'grenada': 5,         // Expansión básica
    'saint-vincent-and-the-grenadines': 5, // Expansión básica
    'tonga': 3,           // Expansión básica
    'seychelles': 3,      // Expansión básica
    'antigua-and-barbuda': 3, // Expansión básica
    'andorra': 3,         // Expansión básica
    'dominica': 3,        // Expansión básica
    'marshall-islands': 3, // Expansión básica
    'saint-kitts-and-nevis': 3, // Expansión básica
    'liechtenstein': 3,   // Expansión básica
    'monaco': 3,          // Expansión básica
    'san-marino': 3,      // Expansión básica
    'tuvalu': 2,          // Expansión básica
    'nauru': 2,           // Expansión básica
    'palau': 2,           // Expansión básica
    'vatican-city': 1     // Caso especial
  },
  populationThreshold: 50000,
  totalTargetCities: 50000 // Meta ultra ambiciosa para cobertura planetaria completa
};
